'use strict';

class RcmFatEvents {
    constructor(fat) {
        this.fat = fat;

        // On context change
        this.onDocumentReady();
        this.onBrowserChangeState();
        //this.setStickyElements();

        // Search related
        this.onFormSubmit();
        this.onSubmitClick();
        this.onFilterInputsSubmit();
        this.onFilterInputClearClick();
        this.onAppliedFiltersClearAllClick();
        this.onAppliedFiltersTagClick();
        this.onFacetClick();
        this.onApplyFiltersClick();
        this.onRequiredFieldsChange();
        this.onGeoFieldsChange();
        this.onPaginationButtonClick();

        // Map related
        this.onListItemHover();

        // Profile related
        this.onListItemClick();
        this.onLeftProfileClick();
        this.onRightProfileClick();
        this.onProfileModalClose();
        this.onProfileModalOpen();
    }

    // On form submit (enter key)
    onFormSubmit() {
        var self = this;

        this.fat.form.requiredFields.on('keypress', function (e) {
            if (e.which == 13) {
                e.preventDefault();
                self.fat.form.submitButton.trigger('click');
                return false;
            }
        });
    }

    // On submit button click
    onSubmitClick() {
        var self = this;

        this.fat.form.submitButton.on('click', function (e) {
            e.preventDefault();

            if (false == self.fat.form.isFormValid()) {
                return false;
            }

            self.fat.callbacks.onBeforeSearch();
            self.fat.algolia.doSearchFromSubmit();
            self.fat.callbacks.onAfterSearch();

            self.fat._helperLogActivity('TPSACT.TeacherSearch', '[NTD] Teachers Searched', document.location.href);
        });
    }

    onFilterInputsSubmit() {
        var self = this;

        this.fat.document.on('keypress', this.fat.resultsFilters.filterInputSelector, function (e) {
            if (e.which == 13) {
                e.preventDefault();
                $(self.fat.resultsFilters.filterInputSubmitSelector).trigger('click');
                return false;
            }
        });

        this.fat.document.on('click', this.fat.resultsFilters.filterInputSubmitSelector, function (e) {
            e.preventDefault();

            var isMobile = !Foundation.MediaQuery.is('xlarge');

            self.fat.callbacks.onBeforeSearch();
            self.fat.algolia.doSearchFiltered(true, isMobile);
            self.fat.callbacks.onAfterSearch();

            self.fat._helperLogActivity('TPSACT.TeacherSearch', '[NTD] Teachers Searched', document.location.href);
        });
    }

    onFilterInputClearClick() {
        var self = this;

        this.fat.document.on('click', this.fat.resultsFilters.filterInputClearSelector, function (e) {
            var input = $(this).siblings('input');

            input.val('');
        });
    }

    onAppliedFiltersClearAllClick() {
        var self = this;

        this.fat.document.on('click', this.fat.resultsFilters.appliedFiltersClearAllSelector, function (e) {
            e.preventDefault();

            $(self.fat.resultsFilters.facetTagsSelector).removeClass('active');

            var isMobile = !Foundation.MediaQuery.is('xlarge');

            self.fat.callbacks.onBeforeSearch();
            self.fat.algolia.doSearchFiltered(true, isMobile); // isFacetFilter = true, isMobile = false (because only on desktop this line is triggered)
            self.fat.callbacks.onAfterSearch();
        });
    }

    onAppliedFiltersTagClick() {
        var self = this;

        this.fat.document.on('click', this.fat.resultsFilters.appliedFiltersTagSelector, function (e) {
            e.preventDefault();

            // find parent in facet dropdowns
            var facet = $(this).data('facet');
            var facetValue = $(this).data('facetValue');
            var facetLink = $(self.fat.resultsFilters.facetLinksSelector + '[data-facet="' + facet + '"]' + '[data-facet-value="' + facetValue + '"]');

            facetLink.parent().toggleClass('active');

            var isMobile = !Foundation.MediaQuery.is('xlarge');

            self.fat.callbacks.onBeforeSearch();
            self.fat.algolia.doSearchFiltered(true, isMobile); // isFacetFilter = true, isMobile = false (because only on desktop this line is triggered)
            self.fat.callbacks.onAfterSearch();
        });
    }

    // On facet link click
    onFacetClick() {
        var self = this;

        this.fat.document.on('click', this.fat.resultsFilters.facetLinksSelector, function (e) {
            e.preventDefault();

            var facet = $(this).data('facet');
            var facetValue = $(this).data('facetValue');
            var facetLinkParent = $(this).parent();

            facetLinkParent.toggleClass('active');
            
            // if the user selects Online for teaching location,
            // log a kentico activity
            if (facet === 'teachingLocation' && facetValue === 'Online' && facetLinkParent.hasClass('active')) {
                self.fat._helperLogActivity('TPSACT.TeacherSearch_OnlineLocation', '[NTD] Teachers Searched (Online Location)', document.location.href);
            }

            // Desktop filters will do the search on facet click
            if ($(this).closest('.fatv2-results-filters').length > 0) {
                self.fat.callbacks.onBeforeSearch();
                self.fat.algolia.doSearchFiltered(true, false); // isFacetFilter = true, isMobile = false (because only on desktop this line is triggered)
                self.fat.callbacks.onAfterSearch();
            }
        });
    }

    // On apply filters button click (mobile)
    onApplyFiltersClick() {
        var self = this;

        this.fat.document.on('click', this.fat.resultsFilters.applyFiltersSelector, function (e) {
            e.preventDefault();

            self.fat.callbacks.onBeforeSearch();
            self.fat.algolia.doSearchFiltered(true, true); // isFacetFilter = true, isMobile = true (because only on mobile this line is triggered)
            self.fat.callbacks.onAfterSearch();

            self.fat._helperLogActivity('TPSACT.TeacherSearch', '[NTD] Teachers Searched', document.location.href);
        });
    }

    // On list item click
    onListItemClick() {
        var self = this;

        this.fat.document.on('click', this.fat.resultsList.listItemSelector, function (e) {
            e.preventDefault();

            var uniqueId = $(this).data('uid');
            var lat = $(this).data('lat');
            var lon = $(this).data('lon');

            self.fat.profile.show(uniqueId, lat, lon);
        });
    }

    // On required fields change
    onRequiredFieldsChange() {
        this.fat.form.requiredFields.on('change_custom', function () {
            var field = $(this);

            field.parent().removeClass('Error');
            field.siblings('.EditingFormErrorLabel').remove();

            if ($.trim(field.val()).length === 0) {
                field.parent().addClass('Error');
                field.after('<span class="EditingFormErrorLabel">This field is required</span>');
            }
        });
    }

    // On geo field change
    onGeoFieldsChange() {
        this.fat.form.geoField.on('change_custom', function () {
            var field = $(this);
            var country = field.data('geoCountry');
            var lat = field.data('geoLat');
            var lng = field.data('geoLng');

            field.parent().removeClass('Error');
            field.siblings('.EditingFormErrorLabel').remove();

            if ($.trim(country).length === 0 || $.trim(lat).length === 0 || $.trim(lng).length === 0) {
                field.parent().addClass('Error');
                field.after('<span class="EditingFormErrorLabel">This field is required</span>');
            }
        });
    }

    // when the pagination changes
    onPaginationButtonClick() {

        var self = this;

        self.fat.document.on('click', '.pager-navs', function (e) {
            e.preventDefault();
            var elem = e.currentTarget;
            if (!elem.classList.contains('disabled')) {

                try {
                    self.fat.mapCurrentPage = parseInt(elem.dataset.targetPage);

                    // check the pagination group
                    if (self.fat.mapCurrentPage < self.fat.mapPageGroup[0]) {
                        var targetFirst = (self.fat.mapCurrentPage - 3 >= 0) ? self.fat.mapCurrentPage - 3 : 0;
                        self.fat.mapPageGroup[0] = targetFirst;
                        self.fat.mapPageGroup[1] = targetFirst + 3;
                    }
                    else if (self.fat.mapCurrentPage > self.fat.mapPageGroup[1]) {
                        var targetLast = (self.fat.mapCurrentPage + 3 < self.fat.resultsPaged.length) ? self.fat.mapCurrentPage + 3 : self.fat.resultsPaged.length;
                        self.fat.mapPageGroup[0] = targetLast - 3;
                        self.fat.mapPageGroup[1] = targetLast;
                    }



                    // re-render the map
                    self.fat.resultsMap.set(false, false, true); // clear, onMapMove, onPageChange
                    // re-render the results list
                    self.fat.resultsList.set();
                }
                catch (err) {
                    console.error(err);
                }
            }


        });
    }

    // On document ready
    // *** THIS IS THE MAIN METHOD OF THE FAT V2, THAT LOADS THE FORM FACETS OR RESULTS BASED ON THE QUERY STRING ***
    onDocumentReady() {
        var self = this;

        this.fat.document.ready(function () {
            self.fat.loader.show();

            if (!self.fat.algolia.doSearchFromQueryString()) {
                self.fat.algolia.populateFacets();
            }

            self.fat.resultsFilters.setAppliedFilters();
        });
    }

    // On browser change state
    onBrowserChangeState() {
        var self = this;

        window.onpopstate = function (event) {
            self.fat.loader.show();

            if (!self.fat.algolia.doSearchFromQueryString()) {
                // self.fat.modules.showPreSearchModule();
                self.fat.loader.hide();
            }
        };
    }

    // On list item hover
    onListItemHover() {
        var self = this;

        this.fat.document.on('mouseenter', this.fat.resultsList.listItemSelector, function (e) {
            e.preventDefault();

            var uniqueId = $(this).data('uid');
            self.fat.resultsMap.startHighlightMarker(uniqueId);
        });

        this.fat.document.on('mouseleave', this.fat.resultsList.listItemSelector, function (e) {
            e.preventDefault();

            var uniqueId = $(this).data('uid');
            self.fat.resultsMap.endHighlightMarker(uniqueId);
        });
    }

    // Sticky elements
    setStickyElements() {
        var self = this;

        this.fat.document.ready(function () {
            setTimeout(function () {
                self._helperSetStickyElements();
                self._helperAdjustStickyElements();
            }, 400);
        });

        this.fat.window.on('scroll', function (e) {
            self._helperSetStickyElements();
        });

        this.fat.window.on('resize', function (e) {
            self._helperAdjustStickyElements();
        });
    }

    // Sticky elements (helper to set)
    _helperSetStickyElements() {
        if ((this.fat.window.scrollTop() > 0 || this.fat.html.offset().top < 0) && this.fat.resultsFilters.filtersWrapper.height() < this.fat.resultsList.list.height()) {
            if (!this.fat.resultsFilters.filtersWrapper.hasClass('sticky-filters-and-map')) {
                this.fat.resultsFilters.filtersWrapper.addClass('sticky-filters-and-map').css('width', this.fat.resultsFilters.filtersWrapper.parent().width());
                this.fat.resultsFilters.appliedFiltersWrapper.addClass('sticky-filters-and-map').css('width', this.fat.resultsList.list.parent().width());
                this.fat.resultsList.list.addClass('sticky-filters-and-map');
            }
        } else {
            this.fat.resultsFilters.filtersWrapper.removeClass('sticky-filters-and-map').css('width', '');
            this.fat.resultsFilters.appliedFiltersWrapper.removeClass('sticky-filters-and-map').css('width', '');
            this.fat.resultsList.list.removeClass('sticky-filters-and-map');
        }
    }

    // Sticky elements (helper to adjust)
    _helperAdjustStickyElements() {
        if (this.fat.resultsFilters.filtersWrapper.hasClass('sticky-filters-and-map')) {
            this.fat.resultsFilters.filtersWrapper.css('width', this.fat.resultsFilters.filtersWrapper.parent().width());
        }
    }

    // On map marker click
    onMapMarkerClick(marker, uniqueId) {
        var self = this;

        // Add a listener to the marker click
        marker.addListener('click', function () {
            var targetElement = self.fat.resultsList.getItemObj(uniqueId);
            // TODO: understand better why I need to subtract 95px here
            // from the scroll top of the list
            // ** seems to be related to flexbox sizing of the applied filters
            var targetElementTop = targetElement[0].offsetTop - 95;

            self.fat.resultsList.list.scrollTop(targetElementTop);

            targetElement.addClass('is-active');

            setTimeout(function () {
                targetElement.removeClass('is-active');
            }, 1000);

            /*
            // Scroll to the related item on list
            self.fat.resultsList.list.stop(true, false).animate({
                // scrollTop: targetElement.position().top + (self.fat.header.height() / 2) - (self.fat.window.height() / 2) + (targetElement.height() / 2) // Trying to keep the item in the middle of the screen
                scrollTop: scrollTop
            }, 250, function () {
                
            });
            */
        });

        return marker;
    }

    // On profile left navigation click
    onLeftProfileClick() {
        var self = this;

        this.fat.document.on('click', this.fat.profile.leftNavSelector, function (e) {
            e.preventDefault();

            if (!$(this).hasClass('active')) {
                return false;
            }

            var currentUniqueId = self.fat._helperGetTeacherUniqueId(self.fat.dataProfile.objectID, self.fat.dataProfile._rankingInfo.matchedGeoLocation.lat, self.fat.dataProfile._rankingInfo.matchedGeoLocation.lng);
            var currentItemOnList = self.fat.resultsList.getItemObj(currentUniqueId);

            var itemOnList = currentItemOnList.prev();
            var uniqueId = itemOnList.data('uid');
            var lat = itemOnList.data('lat');
            var lon = itemOnList.data('lon');

            self.fat.profile.show(uniqueId, lat, lon);
        });
    }

    // On profile right navigation click
    onRightProfileClick() {
        var self = this;

        this.fat.document.on('click', this.fat.profile.rightNavSelector, function (e) {
            e.preventDefault();

            if (!$(this).hasClass('active')) {
                return false;
            }

            var currentUniqueId = self.fat._helperGetTeacherUniqueId(self.fat.dataProfile.objectID, self.fat.dataProfile._rankingInfo.matchedGeoLocation.lat, self.fat.dataProfile._rankingInfo.matchedGeoLocation.lng);
            var currentItemOnList = self.fat.resultsList.getItemObj(currentUniqueId);

            var itemOnList = currentItemOnList.next();
            var uniqueId = itemOnList.data('uid');
            var lat = itemOnList.data('lat');
            var lon = itemOnList.data('lon');

            self.fat.profile.show(uniqueId, lat, lon);
        });
    }

    // On profile modal close
    onProfileModalClose() {
        var self = this;

        this.fat.profile.profile.on('closed.zf.reveal', function () {
            self.fat.profile.hide();
        });
    }

    // On profile modal open
    onProfileModalOpen() {
        var self = this;

        this.fat.profile.profile.on('open.zf.reveal', function () {
            var overlay = self.fat.profile.profile.parent();

            // Fix left/right navigation horizontal position
            if (overlay[0].scrollHeight > overlay[0].clientHeight) {
                self.fat.html.addClass('reveal-has-scroll');
            } else {
                self.fat.html.removeClass('reveal-has-scroll');
            }

            // log kentico marketing activity
            self.fat._helperLogActivity('TPSACT.TeacherProfileViewed', '[NTD] Teachers Profile Viewed (MODAL)', document.location.href);
        });
    }
}
